import { Money } from '@ap/interface-bspc-core';
import { Asset, AssetDetail } from '@ap/ap-interface-apix-hypotheken-berekening';

export class AssetBuilder {
    private amount: Money;
    private detail: AssetDetail;

    withAmount(amount: Money): this {
        this.amount = amount;
        return this;
    }

    withDetail(detail: AssetDetail): this {
        this.detail = detail;
        return this;
    }

    build(): Asset {
        return {
            amount: this.amount,
            detail: this.detail
        } as Asset;
    }
}

export const aAsset = new AssetBuilder();
